import gql from 'graphql-tag';

export const giftCardPaymentSessionOrderDataQuery = gql`
    query GiftCardPaymentSessionOrderData($paymentSessionId: String!) {
        giftCardPaymentSessionOrderData(paymentSessionId: $paymentSessionId) {
            brandName
            brandLogoUrl
            cardBackgroundColor
            cardTextColor
            giftCards {
                faceAmountInCents
                currency
                quantity
            }
            pointsPerFaceValueMajorCurrencyUnit
            conditions {
                title
                text
                shouldBeCrossedOut
            }
            secondaryConditions {
                title
                text
                shouldBeCrossedOut
            }
            conditionsOfUseUrl
        }
    }
`;

type GiftCardCondition = {
    title?: string | null;
    text: string;
    shouldBeCrossedOut?: boolean | null;
};

type GiftCardPaymentSessionOrderDataItem = {
    faceAmountInCents: number;
    currency: string;
    quantity: number;
};

type GiftCardPaymentSessionOrderData = {
    brandName?: string | null;
    brandLogoUrl?: string | null;
    cardBackgroundColor?: string | null;
    cardTextColor?: string | null;
    giftCards: GiftCardPaymentSessionOrderDataItem[];
    pointsPerFaceValueMajorCurrencyUnit?: number | null;
    conditions?: GiftCardCondition[] | null;
    secondaryConditions?: GiftCardCondition[] | null;
    conditionsOfUseUrl?: string | null;
};

export type GiftCardPaymentSessionOrderDataQueryResponse = {
    __typename: 'Query';
    giftCardPaymentSessionOrderData: GiftCardPaymentSessionOrderData | null;
};

export type GiftCardPaymentSessionOrderDataQueryVariables = {
    paymentSessionId: string;
};
